import {
  Checkbox,
  Container,
  Input,
  Label,
  Props,
} from "./CheckboxInput.Parts";

export const CheckboxInput = ({ children, ref, ...rest }: Props) => (
  <Label>
    <Container>{children}</Container>
    <Input type="checkbox" {...rest} ref={ref} />
    <Checkbox />
  </Label>
);
